import { NavLink } from 'react-router-dom';
import { Flex } from '../shared/layouts';

const IconLink = ({ to, title, Icon, onClick, children, hoverColor }) => {
  const isActive = location.pathname === `${to[0] === '/' ? '' : '/'}${to}`;

  return (
    <NavLink
      to={to}
      title={title}
      onClick={onClick}
      css={({ colors }) => {
        const textColor = isActive ? colors?.primaryActive : colors?.primaryFont;
        const textHoverColor = colors?.[hoverColor] || colors.primaryActive;

        return {
          color: textColor,
          svg: { fill: textColor },

          '&:hover': {
            color: textHoverColor,
            svg: { fill: textHoverColor },
          },
        };
      }}
    >
      <Flex alignItems={'center'}>
        {Icon ? <Icon height={'2rem'} /> : null}
        {children ? children : null}
      </Flex>
    </NavLink>
  );
};

export default IconLink;
